import { type FC, type ReactNode } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { STRIPE_KEY } from 'shared/config'
export const StripeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const stripePromise = STRIPE_KEY && loadStripe(STRIPE_KEY)

  return (
    <>
      {stripePromise ? (
        <Elements
          stripe={stripePromise}
          options={{
            locale: 'en',
            fonts: [
              {
                family: 'Inter',
                src: 'url(/assets/Inter-Regular.woff)',
                weight: '400',
                cssSrc: 'https://fonts.googleapis.com/css2?family=Inter&display=swap',
              },
            ],
          }}
        >
          {children}
        </Elements>
      ) : (
        children
      )}
    </>
  )
}
